import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class Utils extends Vue {
  /**
     * Formats unix timestamp to string
  */
  formatDate(timestamp: number): string {
    return timestamp ? moment.unix(timestamp).format('DD/MM/YYYY') : '-';
  }

  /**
   * Formats unix timestamp to string
  */
  formatDateTime(timestamp: number): string {
    return timestamp ? moment.unix(timestamp).format('DD/MM/YYYY HH:mm') : '-';
  }

  /**
   * Formats unix timestamp to string
  */
  formatDateTimeSecond(timestamp: number): string {
    return timestamp ? moment.unix(timestamp).format('DD/MM/YYYY HH:mm:ss') : '-';
  }

  /**
   * Guess the type of a divice from its long ID
   * Temporary method until we store the device type in the history table
   */
  private guessDeviceType(deviceId: string): string {
    const prefix = deviceId.slice(0, 4);
    if (prefix === '1666' || prefix === '3501') {
      return 'obu5gen';
    } if (prefix === '1982') {
      return 'vdolink';
    }
    return '-';
  }

  /**
   * Check if a date range is in the past
   * @param start Start date
   * @param end End date
   * @returns boolean
   */
  isPast(start: number, end: number | undefined) {
    return (start && end && moment().isAfter(moment.unix(end)));
  }

  /**
   * Check if a date range is ongoing
   * @param start Start date
   * @param end End date
   * @returns boolean
   */
  isOngoing(start: number, end: number | undefined) {
    return (start && end && moment().isBetween(moment.unix(start), moment.unix(end))) || (start && !end && moment().isAfter(moment.unix(start)));
  }
}
